import React from 'react';
import { Link } from 'react-router-dom';
import { FiLinkedin } from 'react-icons/fi'; // Import minimal LinkedIn icon
import './Footer.css';

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-logo">
        <Link to="/">
          <img
            src="https://dzsyhtfpcz9op.cloudfront.net/staticResources/logo_intoreality.tv.png"
            alt="Footer Logo"
          />
        </Link>
      </div>

      {/* Social Icons Section with Minimalistic LinkedIn Logo */}
      <div className="footer-social-icons">
        <a
          href="https://www.linkedin.com/company/into-reality-sl/"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-icon"
        >
          <FiLinkedin />
        </a>
      </div>

      {/* Contact Information */}
      <div className="footer-contact">
        <a
          href="mailto:intoreality@intoreality.tv"
          className="footer-contact-link"
        >
          intoreality@intoreality.tv
        </a>
        <span className="footer-contact-separator">|</span>
        <a
          href="https://www.intoreality.es"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-contact-link"
        >
          https://www.intoreality.es
        </a>
      </div>

      {/* Legal Links */}
      <div className="footer-legal-links">
        <Link to="/aviso-legal" className="footer-legal-link">
          Aviso Legal
        </Link>
        <span className="footer-legal-separator">|</span>
        <Link to="/politica-privacidad" className="footer-legal-link">
          Política de Privacidad
        </Link>
        <span className="footer-legal-separator">|</span>
        <Link to="/politica-cookies" className="footer-legal-link">
          Política de Cookies
        </Link>
        <span className="footer-legal-separator">|</span>
        <Link to="/configuracion-cookies" className="footer-legal-link">
          Configuración de Cookies
        </Link>
      </div>

      <div className="footer-copyright">
        <hr />
        <p>Copyright © 2026 - All Rights Reserved.</p>
      </div>
    </div>
  );
};

export default Footer;
